import React, {useState, useEffect} from "react";
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CountryCta=({heading,desc,country,popupHeading,enquiryTitle})=>{
    const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" }
    }
  };

  const [showPopup, setShowPopup] =
      useState(false);

    useEffect(() => {
    
      if (showPopup) {
        document.body.classList.add(
          "popup-open"
        );
      } else {
        document.body.classList.remove(
          "popup-open"
        );
      }
      return () => {
        document.body.classList.remove(
          "popup-open"
        );
      };
    
    }, [showPopup]);

const [loading, setLoading] = useState(false);

const [formData, setFormData] = useState({
  name: "",
  email: "",
  phone: "",
  quantity: "",
  company: "",
  message: "",
});

const handleChange = (e) => {
  const { name, value } = e.target;

  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));
};

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.name)
    return toast.error("Please enter name");

  if (!formData.email)
    return toast.error("Please enter email");

  if (!formData.phone)
    return toast.error("Please enter phone number");

  if (!formData.message)
    return toast.error("Please enter message");


  setLoading(true);

  try {
const template = `
<div
style="
margin:0;
padding:40px 0;
background:#F6F4F0;
font-family:Georgia,'Times New Roman',serif;
"
>

<table width="100%" cellpadding="0" cellspacing="0">
<tr>
<td align="center">

<table
width="720"
cellpadding="0"
cellspacing="0"
style="
background:#ffffff;
border-radius:18px;
overflow:hidden;
box-shadow:0 15px 50px rgba(0,0,0,0.08);
"
>

<!-- TOP ACCENT -->

<tr>
<td style="height:8px;background:#88664D;"></td>
</tr>

<!-- HEADER -->

<tr>
<td
style="
padding:50px 40px;
text-align:center;
background:#FAF8F5;
"
>

<!-- LOGO -->

<!--
<img
src="https://your-domain.com/logo.png"
alt="Iris Impulse India Pvt. Ltd. Logo"
style="max-width:180px;margin-bottom:20px;"
/>
-->

<div
style="
letter-spacing:3px;
font-size:13px;
text-transform:uppercase;
color:#88664D;
margin-bottom:10px;
"
>
IRIS IMPULSE PVT. LTD.
</div>

<h1
style="
margin:0;
font-size:34px;
color:#111;
"
>
New Enquiry for Country
</h1>

<p
style="
margin-top:18px;
font-size:15px;
line-height:1.8;
color:#666;
"
>
A new enquiry has been submitted through the website.
</p>

</td>
</tr>

<!-- HIGHLIGHT SECTION -->

<tr>
<td style="padding:0 45px;">

<div
style="
background:#88664D;
padding:25px;
border-radius:12px;
text-align:center;
"
>

<div
style="
font-size:12px;
letter-spacing:2px;
text-transform:uppercase;
color:#EDE5DF;
margin-bottom:10px;
"
>
Enquiry Details
</div>

${
  enquiryTitle
    ? `
<div
style="
font-size:24px;
font-weight:bold;
color:#fff;
line-height:1.6;
"
>
${enquiryTitle}
</div>
`
    : `
<div
style="
font-size:24px;
font-weight:bold;
color:#fff;
line-height:1.6;
"
>
Bentonite Minerals
</div>

<div
style="
margin-top:10px;
font-size:18px;
color:#F8F2EC;
"
>
Country: ${country?.title || ""}
</div>
`
}

</div>

</td>
</tr>

<!-- CUSTOMER INFO -->

<tr>
<td style="padding:40px 45px;">

<h2
style="
margin:0 0 20px;
font-size:24px;
color:#111;
border-bottom:2px solid #88664D;
padding-bottom:10px;
"
>
Customer Information
</h2>

<table
width="100%"
cellpadding="0"
cellspacing="0"
style="
border:1px solid #EAE3DC;
border-radius:14px;
overflow:hidden;
"
>

<tr>
<td style="padding:18px 24px;border-bottom:1px solid #EAE3DC;">
<span style="color:#777;">Name</span><br/>
<strong>${formData.name}</strong>
</td>
</tr>

<tr>
<td style="padding:18px 24px;border-bottom:1px solid #EAE3DC;">
<span style="color:#777;">Email</span><br/>
<strong>${formData.email}</strong>
</td>
</tr>

<tr>
<td style="padding:18px 24px;border-bottom:1px solid #EAE3DC;">
<span style="color:#777;">Phone Number</span><br/>
<strong>${formData.phone}</strong>
</td>
</tr>

</table>

<!-- BUSINESS INFO -->

<h2
style="
margin:40px 0 20px;
font-size:24px;
color:#111;
border-bottom:2px solid #88664D;
padding-bottom:10px;
"
>
Business Requirement
</h2>

<table
width="100%"
cellpadding="0"
cellspacing="0"
style="
border:1px solid #EAE3DC;
border-radius:14px;
overflow:hidden;
"
>

<tr>
<td style="padding:18px 24px;border-bottom:1px solid #EAE3DC;">
<span style="color:#777;">Company</span><br/>
<strong>${formData.company}</strong>
</td>
</tr>

<tr>
<td style="padding:18px 24px;">
<span style="color:#777;">Required Quantity</span><br/>
<strong>${formData.quantity}</strong>
</td>
</tr>

</table>

<!-- MESSAGE -->

<div style="margin-top:40px;">

<h2
style="
margin-bottom:20px;
font-size:24px;
color:#111;
"
>
Enquiry Message
</h2>

<div
style="
background:#FAF8F5;
border:1px solid #EAE3DC;
padding:25px;
border-radius:14px;
line-height:1.9;
color:#444;
"
>
${formData.message}
</div>

</div>

</td>
</tr>

<!-- FOOTER -->

<tr>
<td
style="
background:#111111;
padding:35px;
text-align:center;
"
>

<div
style="
font-size:18px;
font-weight:bold;
color:#fff;
margin-bottom:8px;
"
>
Iris Impulse India Pvt. Ltd.
</div>

</td>
</tr>

</table>

</td>
</tr>
</table>

</div>
`;
    const data = new FormData();

    data.append(
      "title",
      "Iris Impulse Enquiry Form"
    );

    data.append(
      "to_email",
      "rajan@irisimpulse.com"
    );

    data.append(
      "cc",
       "arkayappsseo@gmail.com,sales@arkayapps.com"
    );

   data.append(
  "subject",
  enquiryTitle
    ? `New Enquiry for ${enquiryTitle}`
    : `New Enquiry for Bentonite Minerals in ${country?.title || ""}`
);

    data.append(
      "template",
      template
    );

    await axios.post(
      "https://api.sendmail.adhyaynam.in/send-mail/two",
      data,
      {
        headers: {
          "Content-Type":
            "multipart/form-data",
        },
      }
    );

    toast.success(
      "Enquiry submitted successfully."
    );

    setFormData({
      name: "",
      email: "",
      phone: "",
      country: "",
      quantity: "",
      company: "",
      message: "",
    });

    setShowPopup(false);

  } catch (error) {

    toast.error(
      "Something went wrong."
    );

  } finally {

    setLoading(false);

  }
};

    return(
        <>
        <section className="cta-section country-cta">
           <ToastContainer
          position="top-right"
          autoClose={3000}
        />
              <motion.div
                className="container"
                initial={{ opacity: 0, scale: 0.98 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, ease: "easeOut" }}
              >
        
                {/* HEADING */}
                <motion.h2
                  className="section-heading"
                  variants={fadeUp}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                >
                 {heading}
                </motion.h2>
        
                {/* TEXT */}
                <motion.p
                  className="section-text"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.2, duration: 0.7 }}
                  viewport={{ once: true }}
                >
                  {desc}
                </motion.p>
               
               <motion.div
                 className="btn-group"
                 variants={fadeUp}
               >
               
                               {/* ENQUIRE BTN */}
            
               <motion.button
                 className="black-btn"
                 whileHover={{ scale: 1.05 }}
                 whileTap={{ scale: 0.97 }}
                 onClick={() =>
                   setShowPopup(true)
                 }
               >
                 ENQUIRE NOW
               </motion.button>
               
               
                               {/* CONTACT BTN */}        
               <motion.a
                 href="/contact-us"
                 className="outline-btn"
                 whileHover={{ scale: 1.05 }}
                 whileTap={{ scale: 0.97 }}
               >
                 GET IN TOUCH
               </motion.a>
                           </motion.div>
            
        
              </motion.div>
        
            </section>

     {/* ===================================
          ENQUIRY POPUP
      =================================== */}

      <AnimatePresence>

        {showPopup && (

          <motion.div
            className="enquiry-popup-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() =>
              setShowPopup(false)
            }
          >

            <motion.div
              className="enquiry-popup"
              initial={{
                opacity: 0,
                y: 60,
                scale: 0.95
              }}
              animate={{
                opacity: 1,
                y: 0,
                scale: 1
              }}
              exit={{
                opacity: 0,
                y: 60,
                scale: 0.95
              }}
              transition={{
                duration: 0.35
              }}
              onClick={(e) =>
                e.stopPropagation()
              }
            >

              {/* CLOSE */}

              <button
                className="enquiry-popup-close"
                onClick={() =>
                  setShowPopup(false)
                }
              >
                ×
              </button>

              {/* HEADING */}

<h4 className="card-heading">

  {popupHeading
    ? popupHeading
    : (
      <>
        Do enquiry for Bentonite Minerals in <br />
        {country?.title}
      </>
    )
  }

</h4>

              {/* FORM */}

              <form className="enquiry-form"
              onSubmit={handleSubmit}>

                <input
                  type="text"
                  placeholder="Name *"
                    name="name"
  value={formData.name}
  onChange={handleChange}
                />

                <input
                  type="tel"
                  placeholder="Phone Number *"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />

                <input
                  type="email"
                  placeholder="Email Address *"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />

                <input
                  type="text"
                  placeholder="Quantity"
                  name="quantity"
                  value={formData.quantity}
                  onChange={handleChange}
                />

                <input
                  type="text"
                  placeholder="Company"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                />

                <textarea
                  rows="5"
                  placeholder="Message *"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                />

                  <button
  type="submit"
  className="black-btn"
  disabled={loading}
>
  {loading
    ? "Submitting..."
    : "SUBMIT ENQUIRY"}
</button>

              </form>

            </motion.div>

          </motion.div>
        )}

      </AnimatePresence>
        </>
    )
}
export default CountryCta;